var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.91797 768.769H199.577L384.161 584.156L568.862 769.096H771.778L383.835 380.963L-1.91797 768.769Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.778 -288.088H570.259L385.699 -103.475L200.998 -288.414H-1.91797L386.025 99.7187L771.778 -288.088Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.672 527.341V423.344L723.205 238.614L907.998 53.791V-48.5283L806.901 -48.0854L520.172 238.94L806.831 524.544L907.672 527.341Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148.674 -48.5283V55.4929L35.7935 240.223L-149 425.045V527.341L-47.8795 526.922L238.85 239.896L-47.8097 -45.7075L-148.674 -48.5283Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkTablet);
export default __webpack_public_path__ + "static/media/watermark-tablet.a9030a668252765532a5f2448e32aa78.svg";
export { ForwardRef as ReactComponent };